import { render, staticRenderFns } from "./groupMessage.vue?vue&type=template&id=2ef38275&scoped=true"
import script from "./groupMessage.vue?vue&type=script&lang=js"
export * from "./groupMessage.vue?vue&type=script&lang=js"
import style0 from "./groupMessage.vue?vue&type=style&index=0&id=2ef38275&prod&scoped=true&lang=scss"
import style1 from "./groupMessage.vue?vue&type=style&index=1&id=2ef38275&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef38275",
  null
  
)

export default component.exports